import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Ecorner/InactivityMonitor/inactivityMonitor.container"
    ).then((module) => ({ default: module.InactivityMonitorContainer }))
);
